import { InvalidContactMessageError } from '../errors/InvalidContactMessageError';

// Intentionally simple RFC-5322-ish pattern: strict enough to catch obvious
// mistakes without rejecting valid but unusual real-world addresses.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Value Object per the pattern established in features/home/domain/value-objects.
 */
export class EmailAddress {
  public readonly value: string;

  private constructor(value: string) {
    this.value = value;
    Object.freeze(this);
  }

  public static create(rawValue: string): EmailAddress {
    const value = rawValue.trim().toLowerCase();
    if (value.length === 0) {
      throw new InvalidContactMessageError('email must not be empty.');
    }
    if (!EMAIL_PATTERN.test(value)) {
      throw new InvalidContactMessageError(`"${rawValue}" is not a valid email address.`);
    }
    return new EmailAddress(value);
  }
}
